import styled from "styled-components";
import { units } from "@m/alchemy-theme";
import { TableCell } from "../table-cell/TableCell";
export const NestedCell = styled(TableCell) `
  padding-left: ${({ nestLevel }) => units(2 * nestLevel + 2)};
`;
